import Axios from 'axios';
import { useContext, useState, useEffect } from 'react';

import FirebaseContext from './firebaseContext';
import {
  politicalParties,
  result as resultEndPoint
} from '../../constants/api';
import { PATH, TYPES } from '../../envs/core';
import Logger from '../../utils/logger';
import useRESTDataCache from '../hooks/useRESTDataCache';
import { arrayToDict } from '../../utils';
import { isAntena3, isLaSexta } from '../../constants/sites';

export const ResultProvider = ({
  active,
  year,
  type,
  subtype = 'SINGLE',
  electionNumber,
  placeId = 'C108',
  electionPlace,
  children,
  onlyWinners = false,
  details = false,
  customPath,
  site
}) => {
  Logger.log('ResultProvider', 'Nuevo render del result provider');
  const { app1, app2, app3, firebase } = useContext(FirebaseContext);
  const [result, setResult] = useState({});

  const matchParties = useRESTDataCache(
    `${PATH}${politicalParties}?year=${year}&typeElection=${type}&numElection=${electionNumber}&regionId=${electionPlace}`,
    'matchParties'
  );
  useEffect(() => {
    setResult({});
    if (matchParties) {
      changeSubscribtion();
    }
    return () => result.currentResultRef && result.currentResultRef().off();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, type, subtype, year, electionNumber, placeId, matchParties]);

  const changeSubscribtion = () => {
    if (result.currentResultRef) {
      result.currentResultRef().off();
    }

    const electionPlacePath =
      type === TYPES.REGIONAL ? `/${electionPlace}` : '';
    const firebasePath =
      customPath ||
      (!details
        ? `${year}/${type}/${subtype}/${electionNumber}${electionPlacePath}/TOTALS/${placeId}`
        : `${year}/${type}/${subtype}/${electionNumber}${electionPlacePath}/TOWNS/${placeId}`);
    Logger.log('changeSubscribtion', `| firebase path: ${firebasePath}`);
    const resultRef = () => firebase.database(app1).ref(firebasePath);
    const resultRef2 = () => firebase.database(app2).ref(firebasePath);
    const resultRef3 = () => firebase.database(app3).ref(firebasePath);

    const successFunction = ({
      data: dataResult,
      resultRef: currentResultRef
    }) => {
      const customAcronym = partyFormat => {
        if (isLaSexta(site)) {
          return partyFormat.laSextaAcronym;
        }
        if (isAntena3(site)) {
          return partyFormat.a3Acronym;
        }
        return partyFormat.partyAcronym;
      };
      const customColor = partyFormat => {
        if (isLaSexta(site)) {
          return partyFormat.laSextaColor;
        }
        if (isAntena3(site)) {
          return partyFormat.a3Color;
        }
        return partyFormat.partyColor;
      };

      if (dataResult) {
        let partyFormats = [];
        if (matchParties) {
          partyFormats = arrayToDict(
            matchParties,
            dataResult.year === 2018 ? 'previousIds' : 'currentId'
          );
        }

        dataResult.abstentionPercent = dataResult.abstentionPercent
          ? dataResult.abstentionPercent.toFixed(2)
          : 0;
        dataResult.currentCountPercent = dataResult.currentCountPercent
          ? dataResult.currentCountPercent.toFixed(2)
          : 0;
        dataResult.invalidPercent = dataResult.invalidPercent
          ? dataResult.invalidPercent.toFixed(2)
          : 0;
        dataResult.participationPercent = dataResult.participationPercent
          ? dataResult.participationPercent.toFixed(2)
          : 0;
        dataResult.whitePercent = dataResult.whitePercent
          ? dataResult.whitePercent.toFixed(2)
          : 0;

        dataResult.partiesResult = dataResult.partiesResult
          ? dataResult.partiesResult
              // .filter(result => result.votesPercent)
              .map(result => {
                const partyFormat = partyFormats[result.id];

                return {
                  ...result,
                  votesPercent: result.votesPercent
                    ? parseFloat(result.votesPercent.toFixed(2))
                    : 0,
                  partyAcronym: partyFormat
                    ? customAcronym(partyFormat)
                    : result.partyAcronym,
                  partyColor: partyFormat
                    ? customColor(partyFormat)
                    : result.partyColor
                };
              })
          : [];
        dataResult.partiesWinners = dataResult.partiesWinners
          ? dataResult.partiesWinners.map(result => {
              const partyFormat = partyFormats[result.id];
              return {
                ...result,
                partyColor: partyFormat
                  ? customColor(partyFormat)
                  : result.partyColor
              };
            })
          : [];
        dataResult.updateDate = new Date(dataResult.updateDate)
          .toTimeString()
          .split(' ')[0];
        dataResult.updateDate =
          dataResult.updateDate !== 'Invalid' ? dataResult.updateDate : '00:00';
      }

      if (onlyWinners) {
        setResult(dataResult.partiesWinners);
      } else {
        setResult(
          dataResult
            ? { ...dataResult, currentResultRef }
            : { currentResultRef }
        );
      }

      Logger.log(
        'ResultProvider.successFunction',
        `Obitene resultados`,
        dataResult,
        'Data result'
      );
    };

    Logger.log(
      'ResultProvider.changeSubscribtion',
      `pide a : ${active ? 'firebase' : 'amazon'}`
    );
    if (active) {
      getFirebaseData(
        [resultRef, resultRef2, resultRef3],
        successFunction,
        callAmazon
      );
    } else {
      callAmazon(successFunction);
    }
  };

  const getFirebaseData = (resultRefs, success, error) => {
    if (resultRefs.length > 0) {
      console.log('ON');
      resultRefs[0]().on(
        'value',
        dataResult => {
          success({ resultRef: resultRefs[0], data: dataResult.val() });
        },
        err => {
          resultRefs.shift();
          getFirebaseData(resultRefs, success, error);
        }
      );
    } else {
      error(success);
    }
  };

  const callAmazon = success => {
    const amazonPath = `${resultEndPoint}/${year}/${type}/${subtype}/${electionNumber}/${placeId ||
      'C108/TOTALS'}`;
    Logger.log('ResultProvider.callAmazon', `amazonPath: ${amazonPath}`);
    Axios.get(`${PATH}${amazonPath}`)
      .then(d => {
        success(d);
      })
      .catch(err => {
        // errror
      });
  };

  if (!matchParties) {
    return null;
  }

  return children(result);
};
